module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="js-cashback-dg" style="display: none">\n	<div class="cashbackDg__header">\n		<div class="popupClose">\n			<i class="icon icon-i16_x"></i>\n		</div>\n	</div>\n\n	<div class="cashbackDg__container">\n		<div class="cashbackDg__logos">\n			<div class="cashbackDg__logos-MIR"></div>\n			×\n			<div class="cashbackDg__logos-rostourism"></div>\n		</div>\n\n		<div class="cashbackDg__blockInfo">'+
((__t=( popupHtml ))==null?'':__t)+
'</div>\n\n		<a class="cashbackDg__blockInfo-button popupClose"\n		   href="'+
((__t=( landingUrl ))==null?'':__t)+
'"\n		   target="_blank">\n			Узнать больше\n		</a>\n	</div>\n</div>\n';
}
return __p;
};
